module.exports = __webpack_public_path__ + "static/media/firstam_christy_keledjian.13f9897e.jpg";